import React from 'react';
import { View, Text, StyleSheet, Pressable, ImageBackground, Dimensions } from 'react-native';
import { useNavigation } from '@react-navigation/native';

const { width, height } = Dimensions.get('window');
const isMobile = width < 768;

const PageUnavailableMessage = ({ reason = 'not_found' }) => {
    const navigation = useNavigation();

    const isWrongAccountType = reason === 'wrong_account_type';

    const heading = isWrongAccountType
        ? "This page isn't available"
        : "Page not found";

    const subtext = isWrongAccountType
        ? "It looks like this graduate has updated their account. Their page is no longer accessible, but you can still find and support other graduates on MyTassel."
        : "We couldn't find the page you're looking for. The link may be outdated or the account may no longer exist.";

    return (
        <ImageBackground
            source={require('../../assets/Hub Background.png')}
            style={styles.background}
            resizeMode="cover"
        >
            <View style={styles.overlay} />
            <View style={styles.centered}>
                <View style={styles.glassCard}>
                    <Text style={styles.whoops}>Whoops...</Text>
                    <View style={styles.divider} />
                    <Text style={styles.heading}>{heading}</Text>
                    <Text style={styles.subtext}>{subtext}</Text>
                    <Pressable
                        style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
                        onPress={() => navigation.navigate('Hub')}
                    >
                        <Text style={styles.buttonText}>Go to MyTassel</Text>
                    </Pressable>
                    <Pressable onPress={() => navigation.goBack()}>
                        <Text style={styles.backLink}>Go back</Text>
                    </Pressable>
                </View>
            </View>
        </ImageBackground>
    );
};

const styles = StyleSheet.create({
    background: {
        flex: 1,
        width: '100%',
        minHeight: '100vh',
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0,0,0,0.18)',
    },
    centered: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 24,
        minHeight: '100vh',
    },
    glassCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.22)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        borderRadius: 20,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.45)',
        padding: isMobile ? 28 : 52,
        maxWidth: 500,
        width: '100%',
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: 0.18,
        shadowRadius: 32,
    },
    whoops: {
        fontFamily: 'Orpheus Pro',
        fontSize: isMobile ? 28 : 36,
        color: '#ffffff',
        fontWeight: '700',
        textAlign: 'center',
        marginBottom: 12,
        textShadowColor: 'rgba(0,0,0,0.25)',
        textShadowOffset: { width: 0, height: 2 },
        textShadowRadius: 8,
    },
    divider: {
        width: 36,
        height: 2,
        backgroundColor: 'rgba(255,255,255,0.6)',
        borderRadius: 2,
        marginBottom: 20,
    },
    heading: {
        fontFamily: 'Orpheus Pro',
        fontSize: isMobile ? 18 : 22,
        color: '#ffffff',
        fontWeight: '600',
        textAlign: 'center',
        marginBottom: 12,
        textShadowColor: 'rgba(0,0,0,0.2)',
        textShadowOffset: { width: 0, height: 1 },
        textShadowRadius: 4,
    },
    subtext: {
        fontFamily: 'Orpheus Pro',
        fontSize: isMobile ? 14 : 15,
        color: 'rgba(255,255,255,0.85)',
        textAlign: 'center',
        lineHeight: isMobile ? 22 : 24,
        marginBottom: 32,
    },
    button: {
        backgroundColor: '#4c956c',
        paddingVertical: 14,
        paddingHorizontal: 32,
        borderRadius: 8,
        width: '100%',
        alignItems: 'center',
        marginBottom: 16,
    },
    buttonPressed: {
        backgroundColor: '#3a7a56',
    },
    buttonText: {
        color: '#ffffff',
        fontSize: 15,
        fontWeight: '600',
        fontFamily: 'Orpheus Pro',
    },
    backLink: {
        color: 'rgba(255,255,255,0.75)',
        fontSize: 14,
        fontFamily: 'Orpheus Pro',
        textDecorationLine: 'underline',
    },
});

export default PageUnavailableMessage;
